import { render } from "./ProjectKanban.vue?vue&type=template&id=223a4ffc"
import script from "./ProjectKanban.vue?vue&type=script&lang=js"
export * from "./ProjectKanban.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__